import React from 'react'
import Footer from '../Footer'
import ImageInkFour from '../ImageInkFour'

function ImgInkFour() {
    window.scrollTo(0,0);
    return (
        <div>
            <ImageInkFour/>
            <Footer/>
        </div>
    )
}

export default ImgInkFour
